import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

const container: CSSProperties = {};

const row: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

const intro: CSSProperties = {
  color: greys.slate,
  fontSize: 14,
  lineHeight: 1.5,
  marginLeft: 10,
};

export const styles = {
  container,
  row,
  intro,
};
